import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@affinite/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogAuthComponent } from './dialog-auth.component';
import { DirectivesModule } from '../../../directive/directives.module';
import { PipesModule } from '@affinite/common';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    DirectivesModule,
    PipesModule
  ],
  declarations: [
    DialogAuthComponent
  ],
  exports: [
    DialogAuthComponent
  ]
})
export class DialogAuthModule { }
